import React from "react";
import CallPickIllustration from "../../assets/illustrations/CallPickIllustration";
import ShowOrderNumberIllustration from "../../assets/illustrations/ShowOrderNumberIllustration";
import useTheme from "../../hooks/useTheme";
import {useTranslation} from "react-i18next";

export default function PickUpInstructions() {
  const {t} = useTranslation(null, {keyPrefix: 'Components:PickUp:PickUpInstructions'});

  const theme = useTheme();

  let OPTIONS = [
    {
      id: 1,
      subTitle: t('options.option_1.subTitle'),
      title: t('options.option_1.title'),
      description: t('options.option_1.description'),
      icon: (
        <ShowOrderNumberIllustration
          className={iconStyle}
          color={theme.color.brand.primary}
        />
      ),
    },
    {
      id: 2,
      subTitle: t('options.option_2.subTitle'),
      title: t('options.option_2.title'),
      description: t('options.option_2.description'),
      icon: (
        <CallPickIllustration
          className={iconStyle}
          color={theme.color.brand.primary}
        />
      ),
    },
  ];

  function renderOption(option: any, index: number) {
    return (
      <div
        className={optionItemContainer}
        style={{
          marginTop:
            OPTIONS?.length - 1 === index ? theme.dimension.padding.small : 0,
        }}
        key={option?.id?.toString()}
      >
        <div className="mr-3">{option?.icon}</div>
        <div>
          <h4>
            {option?.id}. {option?.subTitle}
          </h4>
          <p>{option?.description}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={container}>
      <div>
        <div className={highlightContainer}>
          <h4 className={instructionStyle}>{t('instructions')}</h4>
        </div>
        <div className={optionContainer}>
          {OPTIONS?.map((item, index) => renderOption(item, index))}
        </div>
      </div>
    </div>
  );
}

const container = "w-full rounded-lg shadow-lg overflow-hidden";

const highlightContainer = "p-4 mb-2 bg-brand-warning";

const instructionStyle = "text-center text-brand-text-default";

const optionContainer = "p-4";

const optionItemContainer = "flex flex-row";

const iconStyle = "h-20 w-20";
